const initSelect = function () {

		const $renSelect = $('.ren-select');

		if ($renSelect.length) {
			/* Anything that gets to the document will hide the dropdown */
			$(document).on('click', function (e) {
				if (!$(e.target).closest('.ren-select').length) {
					$renSelect.removeClass('ren-select--opened');
				}
			});
			/* Clicks within the dropdown won't make it past the dropdown itself */
			$renSelect.on('click', function () {
				$(this).toggleClass('ren-select--opened');
				$renSelect.not(this).each(function () {
					$(this).removeClass('ren-select--opened');
				});
			});
		}
};

export default initSelect;
